import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import { pendo, agGrid } from 'config';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { LicenseManager } from 'ag-grid-enterprise';

import Auth from 'modules/Auth';
import { setupRequestInterceptors } from 'modules/api/request';

import 'stylesheets/tailwind.css';

import store from 'store';
import App from 'components/common/App';

import { loadPendo } from 'vendor/pendo';

import '!style-loader!css-loader!normalize.css'; /* eslint-disable-line import/no-webpack-loader-syntax */
import 'react-day-picker/dist/style.css';
import 'stylesheets/global.pcss';

import { dataDogInitialise } from 'modules/DataDog';

LicenseManager.setLicenseKey(agGrid.enterpriseKey);

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element with id "root" not found');
}

const root = createRoot(rootElement);

const render = async (): Promise<void> => {
  try {
    await Auth.init();

    setupRequestInterceptors();

    root.render(
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>,
    );
  } catch {
    root.render(<div>Authentication error</div>);
  }
};

render();

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./components/common/App', () => {
    render();
  });
}

if (process.env.NODE_ENV === 'production') {
  loadPendo(pendo.subscriptionKey);
}

dataDogInitialise();
